export type TitleKind = "movie" | "tv";

export interface FilmTitle {
  id: string;
  title: string;
  origTitle: string;
  kind: TitleKind;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  views: number;
  duration: string;
  director: string;
  cast: string[];
  cover: string;
  backdrop: string;
  synopsis: string;
  tags: string[];
  episodes?: number;
}

export const titles: FilmTitle[] = [
  {
    id: "deep-blue-line",
    title: "深海蓝线",
    origTitle: "The Deep Blue Line",
    kind: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "悬疑", "冒险"],
    rating: 4.8,
    views: 1286000,
    duration: "128分钟",
    director: "程砚舟",
    cast: ["陈屿", "林见川", "苏以宁"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20vertical%20movie%20poster%20design%2C%20deep%20navy%20ocean%20trench%20with%20a%20lone%20glowing%20submarine%20light%20beam%2C%20dark%20moody%20atmosphere%2C%20minimal%20typography%20space%20at%20bottom%2C%20elegant%20sci-fi%20thriller%20aesthetic%2C%20high%20contrast%20dramatic%20lighting%2C%20premium%20film%20key%20art&width=600&height=900&seq=cc-film-poster-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=epic%20wide%20cinematic%20scene%20of%20a%20deep%20ocean%20research%20station%20underwater%20with%20deep%20navy%20tones%20and%20a%20single%20orange%20light%20beam%20cutting%20through%20dark%20water%2C%20sci-fi%20atmosphere%2C%20volumetric%20light%2C%20film%20still%20quality%2C%20dark%20low%20key%20composition&width=1600&height=900&seq=cc-film-backdrop-01&orientation=landscape",
    synopsis:
      "一支深海科考队在马里亚纳海沟一千一百米处发现了一段不属于任何已知文明的低频信号。随着下潜深度的增加，队长陆沉发现自己看到的并不只是海底，而是某种正在回望他们的东西。当氧气余量只剩下六小时，团队必须决定：带回真相，还是带回所有人。",
    tags: ["4K 超清", "独家", "悬疑烧脑"],
  },
  {
    id: "city-of-glass",
    title: "玻璃之城",
    origTitle: "City of Glass",
    kind: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["剧情", "犯罪"],
    rating: 4.6,
    views: 942000,
    duration: "116分钟",
    director: "何知微",
    cast: ["梁隽哲", "周映真", "曾昭"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20neon-lit%20hong%20kong%20street%20at%20night%20seen%20through%20rain-streaked%20glass%2C%20silhouette%20of%20a%20man%20in%20a%20trench%20coat%2C%20silver%20grey%20and%20orange%20accents%2C%20noir%20crime%20drama%20mood%2C%20premium%20film%20key%20art%2C%20high%20detail&width=600&height=900&seq=cc-film-poster-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20cityscape%20of%20a%20futuristic%20glass%20tower%20district%20at%20dusk%2C%20silver%20grey%20and%20warm%20orange%20lighting%2C%20reflective%20surfaces%2C%20crime%20drama%20film%20still%2C%20moody%20atmosphere%2C%20shallow%20depth%2C%20editorial%20cinematography&width=1600&height=900&seq=cc-film-backdrop-02&orientation=landscape",
    synopsis:
      "金融调查员程一舟在追查一桩旧案时，发现整座城市的玻璃幕墙里都藏着同一场交易的倒影。曾经的朋友、如今的对手，以及一个被反复改写的时间线，让他分不清自己究竟是在查案，还是在替某人抹去证据。",
    tags: ["口碑佳作", "港片新势力"],
  },
  {
    id: "spring-on-the-plateau",
    title: "高原上的春天",
    origTitle: "Spring on the Plateau",
    kind: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "家庭", "文艺"],
    rating: 4.7,
    views: 586000,
    duration: "132分钟",
    director: "桑吉卓玛",
    cast: ["普布次仁", "德吉央宗", "许知遥"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20arthouse%20film%20poster%20showing%20a%20lone%20child%20on%20a%20vast%20tibetan%20plateau%20with%20wind%20sweeping%20grass%2C%20silver%20grey%20sky%20with%20a%20warm%20orange%20sunrise%20glow%2C%20delicate%20minimal%20composition%2C%20poetic%20cinematic%20style%2C%20soft%20film%20grain&width=600&height=900&seq=cc-film-poster-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20sweeping%20landscape%20of%20the%20tibetan%20plateau%20at%20golden%20hour%2C%20silver%20grey%20mountains%20with%20warm%20orange%20sunlight%2C%20a%20single%20small%20figure%20walking%20a%20dirt%20road%2C%20poetic%20arthouse%20film%20still%2C%20soft%20natural%20light%2C%20atmospheric%20haze&width=1600&height=900&seq=cc-film-backdrop-03&orientation=landscape",
    synopsis:
      "一位在上海做外卖骑手的母亲，把十二岁的儿子留在高原老家三年。当她终于带着攒下的钱回到牧场，儿子已经学会了一个人放羊、一个人煮饭，也学会了对她说“我不需要你”。这个春天，她决定用一整个夏天重新认识自己的孩子。",
    tags: ["影展入围", "温情治愈"],
  },
  {
    id: "the-last-clockmaker",
    title: "最后的钟表匠",
    origTitle: "The Last Clockmaker",
    kind: "movie",
    year: 2023,
    region: "英国",
    genres: ["剧情", "奇幻"],
    rating: 4.5,
    views: 733000,
    duration: "121分钟",
    director: "Elliot Marsh",
    cast: ["Thomas Reilly", "Eleanor Pike", "林雅思"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20vintage%20cinematic%20poster%20of%20an%20old%20clockmaker%20shop%20interior%20filled%20with%20hundreds%20of%20brass%20clocks%2C%20warm%20amber%20and%20silver%20grey%20tones%2C%20dust%20in%20sunbeams%2C%20magical%20realism%20film%20key%20art%2C%20rich%20texture%2C%20premium%20detail&width=600&height=900&seq=cc-film-poster-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20cozy%20cluttered%20clockmaker%20workshop%20at%20night%20illuminated%20by%20warm%20orange%20lamplight%2C%20brass%20gears%20and%20pendulums%2C%20silver%20grey%20shadows%2C%20magical%20realism%20mood%2C%20intricate%20detail%2C%20film%20still&width=1600&height=900&seq=cc-film-backdrop-04&orientation=landscape",
    synopsis:
      "小镇上最后一位钟表匠被告知：镇上每一座钟的停摆，都对应着一个居民的离世。当他自己家的那座老钟开始走慢，他必须在一个月内修好它——或者接受时间本来的样子。",
    tags: ["奇幻", "英伦风情"],
  },
  {
    id: "chasing-the-light",
    title: "追光者",
    origTitle: "Chasing the Light",
    kind: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["动作", "剧情", "运动"],
    rating: 4.4,
    views: 1105000,
    duration: "107分钟",
    director: "郑柏岩",
    cast: ["雷嘉树", "莫雨青"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20sports%20drama%20movie%20poster%20of%20a%20cyclist%20silhouette%20racing%20into%20a%20tunnel%20of%20orange%20light%2C%20dark%20navy%20background%2C%20dynamic%20motion%20blur%2C%20high%20energy%20composition%2C%20premium%20film%20key%20art%2C%20strong%20contrast&width=600&height=900&seq=cc-film-poster-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20cyclists%20racing%20along%20a%20mountain%20road%20at%20sunset%2C%20deep%20navy%20sky%20with%20bright%20orange%20horizon%20glow%2C%20motion%20blur%2C%20sports%20drama%20film%20still%2C%20dramatic%20backlight&width=1600&height=900&seq=cc-film-backdrop-05&orientation=landscape",
    synopsis:
      "退役四年的场地自行车选手周野，在一场业余比赛里被一个送外卖的少年甩开半个车身。为了把少年送进省队，他重新骑上那辆生锈的车，也开始面对当年那场让自己退赛的事故。",
    tags: ["热血", "真实改编"],
  },
  {
    id: "rain-on-nanjing-road",
    title: "南京路有雨",
    origTitle: "Rain on Nanjing Road",
    kind: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    rating: 4.3,
    views: 688000,
    duration: "104分钟",
    director: "沈迟",
    cast: ["方念安", "蒋启明", "陈棠"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20romantic%20drama%20poster%20of%20two%20people%20sharing%20one%20umbrella%20on%20a%20rainy%20city%20street%20at%20night%2C%20silver%20grey%20rain%20and%20warm%20orange%20streetlamp%20reflections%2C%20soft%20bokeh%2C%20nostalgic%20melancholy%20mood%2C%20elegant%20minimal%20poster%20design&width=600&height=900&seq=cc-film-poster-06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20rainy%20night%20city%20street%20with%20wet%20asphalt%20reflecting%20silver%20grey%20light%20and%20warm%20orange%20shop%20signs%2C%20a%20couple%20walking%20away%20from%20camera%2C%20romantic%20drama%20film%20still%2C%20soft%20focus%20background&width=1600&height=900&seq=cc-film-backdrop-06&orientation=landscape",
    synopsis:
      "2010年的南京路，两个在唱片店打工的年轻人因为一张错放的专辑认识。十二年里，他们反复走散又反复重逢，直到那座唱片店要拆掉的那个雨夜，才有人真正说出那句迟到很久的话。",
    tags: ["治愈", "都市情感"],
  },
  {
    id: "shadow-division",
    title: "暗影分局",
    origTitle: "Shadow Division",
    kind: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "刑侦", "剧情"],
    rating: 4.7,
    views: 2960000,
    duration: "更新至30集 / 共36集",
    episodes: 36,
    director: "赵屹",
    cast: ["郑岩松", "许宁", "毛雨旗", "唐一诺"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20crime%20series%20poster%20showing%20a%20detective%20silhouette%20in%20a%20dark%20office%20with%20case%20files%20pinned%20on%20a%20board%2C%20deep%20navy%20shadows%20with%20one%20thin%20orange%20light%20line%2C%20gritty%20procedural%20mood%2C%20premium%20streaming%20key%20art&width=600&height=900&seq=cc-film-poster-07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20police%20briefing%20room%20at%20night%2C%20deep%20navy%20shadows%20with%20orange%20projector%20light%20on%20a%20wall%20of%20evidence%20photos%2C%20investigation%20thriller%20series%20still%2C%20tense%20atmosphere&width=1600&height=900&seq=cc-film-backdrop-07&orientation=landscape",
    synopsis:
      "一支连续七年零破案率的边缘小组，被临时借调调查一宗看似普通的失踪案。组长沈砚却发现，所有线索的终点都指向自己十年前亲手结案的卷宗。三十集里，真相一层层剥开，也一层层把人往下拉。",
    tags: ["独播", "年度热度王", "全36集"],
  },
  {
    id: "midnight-diner-2025",
    title: "深夜食堂·夜航",
    origTitle: "Midnight Diner: Night Voyage",
    kind: "tv",
    year: 2024,
    region: "日本",
    genres: ["剧情", "治愈", "美食"],
    rating: 4.6,
    views: 1740000,
    duration: "更新至20集 / 共20集",
    episodes: 20,
    director: "森田葵",
    cast: ["大和田透", "小林美绪", "陈愿"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20warm%20japanese%20food%20drama%20poster%20of%20a%20tiny%20midnight%20diner%20counter%20with%20steaming%20bowls%2C%20amber%20orange%20lamp%20glow%20against%20dark%20navy%20night%2C%20cozy%20intimate%20mood%2C%20film%20still%20key%20art%2C%20soft%20bokeh&width=600&height=900&seq=cc-film-poster-08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20small%20japanese%20diner%20at%20midnight%20with%20warm%20orange%20lantern%20light%20and%20steam%20rising%20from%20the%20kitchen%20counter%2C%20deep%20navy%20blue%20night%20outside%2C%20cozy%20healing%20drama%20still%2C%20shallow%20depth%20of%20field&width=1600&height=900&seq=cc-film-backdrop-08&orientation=landscape",
    synopsis:
      "在一条没有名字的港口街上，有一家只在凌晨开门的食堂。每一集，一位陌生客人在饭桌上讲出自己的故事，而老板只用一碗热汤回应。二十集，二十种在此靠岸的人生。",
    tags: ["高分治愈", "全20集"],
  },
  {
    id: "the-archive-of-silence",
    title: "沉默档案",
    origTitle: "The Archive of Silence",
    kind: "tv",
    year: 2023,
    region: "韩国",
    genres: ["悬疑", "律政", "惊悚"],
    rating: 4.5,
    views: 1350000,
    duration: "全16集",
    episodes: 16,
    director: "박서윤",
    cast: ["이도현", "김하은", "徐知源"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20legal%20thriller%20series%20poster%20of%20a%20woman%20in%20a%20grey%20suit%20standing%20in%20a%20vast%20empty%20archive%20hall%2C%20deep%20navy%20shadows%20and%20a%20single%20orange%20exit%20sign%2C%20cold%20institutional%20architecture%2C%20premium%20streaming%20key%20art&width=600&height=900&seq=cc-film-poster-09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20endless%20archive%20hall%20with%20rows%20of%20file%20shelves%2C%20cold%20silver%20grey%20light%20with%20small%20orange%20indicator%20lamps%2C%20legal%20thriller%20series%20still%2C%20symmetrical%20one%20point%20perspective&width=1600&height=900&seq=cc-film-backdrop-09&orientation=landscape",
    synopsis:
      "一位只能通过文字与人交流的年轻检察官，接手了一桩所有人都保持沉默的旧案。她发现，卷宗里被划掉的那几行，比留下的内容更重要。十六集里，她一本本翻开那些被归档的沉默。",
    tags: ["高分悬疑", "全16集"],
  },
  {
    id: "future-perfect",
    title: "未来时态",
    origTitle: "Future Perfect",
    kind: "tv",
    year: 2025,
    region: "美国",
    genres: ["科幻", "悬疑", "剧情"],
    rating: 4.4,
    views: 2240000,
    duration: "更新至8集 / 共10集",
    episodes: 10,
    director: "Nadia Vance",
    cast: ["Owen Mercer", "Clara Boyd", "林梓乔"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20sci-fi%20series%20poster%20showing%20a%20person%20split%20across%20two%20parallel%20timelines%20with%20mirrored%20city%20skyline%2C%20deep%20navy%20and%20silver%20grey%20palette%20with%20orange%20glitch%20accents%2C%20minimal%20futuristic%20design&width=600&height=900&seq=cc-film-poster-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20futuristic%20control%20room%20with%20holographic%20timeline%20displays%2C%20deep%20navy%20interior%20with%20orange%20hologram%20lines%2C%20sci-fi%20thriller%20series%20still%2C%20volumetric%20lighting%2C%20high%20detail&width=1600&height=900&seq=cc-film-backdrop-10&orientation=landscape",
    synopsis:
      "科学家艾拉发明了一台只能接收未来三小时记忆的机器。她用它阻止了十七场事故，直到某天机器里出现了她自己死去的记忆。为了弄明白发生了什么，她必须在剩下的三小时里，和自己的未来赛跑。",
    tags: ["独家", "科幻新作"],
  },
  {
    id: "born-to-the-stage",
    title: "生而为舞台",
    origTitle: "Born to the Stage",
    kind: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "音乐", "职场"],
    rating: 4.3,
    views: 1560000,
    duration: "全24集",
    episodes: 24,
    director: "徐立言",
    cast: ["汤知夏", "储亦然", "尹清", "关牧"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20music%20drama%20poster%20of%20a%20young%20singer%20on%20a%20dark%20stage%20under%20a%20warm%20orange%20spotlight%2C%20silver%20grey%20haze%20and%20silhouetted%20audience%2C%20emotive%20theatrical%20composition%2C%20premium%20series%20key%20art&width=600&height=900&seq=cc-film-poster-11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20grand%20theatre%20auditorium%20from%20the%20stage%2C%20empty%20red%20seats%20in%20deep%20shadow%2C%20single%20warm%20orange%20spotlight%20beam%2C%20silver%20grey%20haze%2C%20dramatic%20musical%20drama%20still&width=1600&height=900&seq=cc-film-backdrop-11&orientation=landscape",
    synopsis:
      "一个从县城来的伴舞，在一次晚会事故中被迫站到台前。二十四集里，她要面对的从来不是天赋问题，而是谁有资格被听见。",
    tags: ["全24集", "音乐题材"],
  },
  {
    id: "mountain-railway",
    title: "山线列车",
    origTitle: "Mountain Railway",
    kind: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["年代", "剧情"],
    rating: 4.6,
    views: 980000,
    duration: "全28集",
    episodes: 28,
    director: "梁暮",
    cast: ["老秦", "罗娟", "柳少白"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20period%20drama%20poster%20of%20an%20old%20green%20train%20crossing%20a%20mountain%20viaduct%20in%20mist%2C%20silver%20grey%20fog%20with%20warm%20orange%20headlight%2C%20nostalgic%20film%20grain%2C%20restrained%20minimal%20composition%2C%20premium%20chinese%20tv%20key%20art&width=600&height=900&seq=cc-film-poster-12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20old%20train%20traveling%20through%20misty%20mountain%20passes%20at%20dawn%2C%20silver%20grey%20fog%2C%20warm%20orange%20sunrise%20breaking%20through%2C%20period%20chinese%20drama%20still%2C%20epic%20landscape&width=1600&height=900&seq=cc-film-backdrop-12&orientation=landscape",
    synopsis:
      "1987年，一条通进大山的铁路让三个家庭的生活彻底改了方向。二十八集，从绿皮车的第一声汽笛，一直讲到站台拆掉的那天。",
    tags: ["年代质感", "全28集"],
  },
  {
    id: "paper-moon",
    title: "纸月亮",
    origTitle: "Paper Moon",
    kind: "movie",
    year: 2021,
    region: "法国",
    genres: ["爱情", "文艺"],
    rating: 4.2,
    views: 412000,
    duration: "98分钟",
    director: "Camille Rousseau",
    cast: ["Luc Ferrand", "Élise Vannier"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20french%20romance%20arthouse%20poster%20of%20a%20woman%20looking%20up%20at%20a%20paper%20moon%20hanging%20in%20a%20hazy%20night%20sky%2C%20silver%20grey%20and%20muted%20orange%20palette%2C%20soft%20analog%20film%20texture%2C%20minimal%20elegant%20design&width=600&height=900&seq=cc-film-poster-13&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20shot%20of%20a%20parisian%20rooftop%20at%20night%20with%20a%20large%20paper%20moon%20prop%20hanging%20between%20chimneys%2C%20silver%20grey%20haze%20and%20warm%20orange%20window%20lights%2C%20dreamy%20arthouse%20film%20still&width=1600&height=900&seq=cc-film-backdrop-13&orientation=landscape",
    synopsis:
      "一位舞台布景师和一个失眠的钢琴调音师，在一个只有月亮道具的天台上相爱。他们都知道，布景迟早要拆。",
    tags: ["法式浪漫", "文艺片"],
  },
  {
    id: "iron-vow",
    title: "铁血之约",
    origTitle: "Iron Vow",
    kind: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["战争", "历史", "剧情"],
    rating: 4.4,
    views: 866000,
    duration: "141分钟",
    director: "霍长川",
    cast: ["申振宇", "吕严", "贺婉"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20historical%20war%20film%20poster%20of%20soldiers%20silhouettes%20on%20a%20snowy%20ridge%2C%20deep%20navy%20storm%20sky%20with%20a%20single%20warm%20orange%20flare%2C%20gritty%20textured%20gradient%2C%20epic%20restrained%20composition&width=600&height=900&seq=cc-film-poster-14&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20soldiers%20marching%20across%20a%20snowy%20field%20in%20a%20blizzard%2C%20deep%20navy%20sky%20with%20one%20warm%20orange%20flare%20in%20the%20distance%2C%20historical%20war%20epic%20film%20still%2C%20desaturated%20palette%2C%20epic%20scale&width=1600&height=900&seq=cc-film-backdrop-14&orientation=landscape",
    synopsis:
      "1944年冬，一支后勤运输队在暴风雪中护送一批药品穿越封锁线。他们没有英雄的名号，只有一句在出发前彼此许下的约定：一个不少地带回去。",
    tags: ["史诗", "真实战役改编"],
  },
  {
    id: "little-giant-chef",
    title: "小小巨人厨房",
    origTitle: "Little Giant Kitchen",
    kind: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["动画", "亲子", "喜剧"],
    rating: 4.1,
    views: 640000,
    duration: "全52集",
    episodes: 52,
    director: "叶小满",
    cast: ["配音：阿布", "配音：桃桃"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20colorful%20animated%20kids%20series%20poster%20of%20a%20tiny%20chef%20with%20a%20huge%20hat%20in%20a%20bright%20kitchen%20filled%20with%20friendly%20vegetables%2C%20charming%20flat%20illustration%20style%2C%20warm%20orange%20and%20navy%20accents%2C%20playful%20composition&width=600&height=900&seq=cc-film-poster-15&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20colorful%20animated%20scene%20of%20a%20fantasy%20kitchen%20with%20talking%20vegetables%20and%20a%20tiny%20chef%2C%20warm%20orange%20and%20deep%20navy%20palette%2C%20friendly%20flat%20illustration%20style%2C%20cozy%20lighting&width=1600&height=900&seq=cc-film-backdrop-15&orientation=landscape",
    synopsis:
      "在一间会自己长蔬菜的厨房里，小厨师阿布每天都要解决一个麻烦：会逃跑的饺子、吵架的胡萝卜，还有总想偷吃的小猫。每集一道菜，一个道理。",
    tags: ["亲子", "全52集"],
  },
  {
    id: "the-long-summer-of-98",
    title: "九八年的长夏",
    origTitle: "The Long Summer of 98",
    kind: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "剧情", "成长"],
    rating: 4.5,
    views: 521000,
    duration: "112分钟",
    director: "戴行舟",
    cast: ["宁子昂", "陆晓禾", "闵川"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20coming%20of%20age%20film%20poster%20of%20four%20teenagers%20sitting%20on%20a%20river%20dam%20at%20dusk%2C%20silver%20grey%20sky%20with%20warm%20orange%20sunset%2C%20nostalgic%20film%20grain%2C%20wistful%20composition%2C%20restrained%20minimal%20design&width=600&height=900&seq=cc-film-poster-16&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20nostalgic%20shot%20of%20teenagers%20cycling%20along%20a%20riverside%20road%20in%201998%20summer%2C%20silver%20grey%20haze%20with%20warm%20orange%20late%20afternoon%20light%2C%20film%20grain%2C%20nostalgic%20chinese%20youth%20film%20still&width=1600&height=900&seq=cc-film-backdrop-16&orientation=landscape",
    synopsis:
      "1998年的夏天，四个少年决定在开学前做一件会被记住的事。那年长江的水位一直在涨，而他们的秘密就藏在堤坝下面的铁皮屋里。",
    tags: ["青春回忆", "口碑佳作"],
  },
  {
    id: "neon-precinct",
    title: "霓虹特区",
    origTitle: "Neon Precinct",
    kind: "tv",
    year: 2024,
    region: "中国香港",
    genres: ["犯罪", "动作", "悬疑"],
    rating: 4.2,
    views: 1120000,
    duration: "全18集",
    episodes: 18,
    director: "尹家豪",
    cast: ["陈展鹏", "黄静言", "古天朗"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20neon%20noir%20crime%20series%20poster%20of%20a%20rain-soaked%20alley%20with%20layered%20neon%20signs%20in%20orange%20and%20cool%20grey%2C%20lone%20detective%20figure%20with%20umbrella%2C%20high%20contrast%20atmosphere%2C%20premium%20key%20art&width=600&height=900&seq=cc-film-poster-17&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20neon-lit%20hong%20kong%20alley%20at%20night%20in%20heavy%20rain%2C%20layered%20orange%20and%20silver%20grey%20neon%20reflections%2C%20crime%20thriller%20series%20still%2C%20moody%20high%20contrast&width=1600&height=900&seq=cc-film-backdrop-17&orientation=landscape",
    synopsis:
      "在一座被霓虹照亮的特区里，一桩失踪案把两个互不信任的部门绑在一起。十八集，每一集揭开一层街区地图背后的人情账。",
    tags: ["港剧", "全18集"],
  },
  {
    id: "a-letter-to-the-sea",
    title: "给海的信",
    origTitle: "A Letter to the Sea",
    kind: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 4.6,
    views: 358000,
    duration: "109分钟",
    director: "林望舒",
    cast: ["何蔚", "陈牧之", "周听澜"],
    cover: "https://readdy.ai/api/search-image?query=vertical%20quiet%20family%20drama%20poster%20of%20a%20child%20holding%20a%20letter%20on%20a%20small%20fishing%20boat%20at%20dawn%2C%20silver%20grey%20sea%20and%20sky%20with%20warm%20orange%20horizon%2C%20minimal%20poetic%20composition%2C%20soft%20film%20texture&width=600&height=900&seq=cc-film-poster-18&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=wide%20cinematic%20shot%20of%20a%20small%20fishing%20boat%20on%20a%20calm%20silver%20grey%20sea%20at%20dawn%2C%20warm%20orange%20light%20spreading%20across%20the%20horizon%2C%20minimal%20poetic%20film%20still%2C%20soft%20mist%2C%20serene%20atmosphere&width=1600&height=900&seq=cc-film-backdrop-18&orientation=landscape",
    synopsis:
      "父亲去世后，女儿在他的渔船舱底找到四十七封写给海、却从未寄出的信。她决定沿着信里提到的每一个坐标，把这封最后一封信送到终点。",
    tags: ["新片上映", "温情治愈"],
  },
];